"use client";

import * as React from "react";
import { CircleCheck, Settings2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const equipmentData = [{
  id: "eq-1",
  name: "Bandit Intimidator 19XP",
  model: "TRACKED WOOD CHIPPER",
  specs: ["19-inch chipping capacity", "Caterpillar C7.1 275 HP engine", "Tracked undercarriage for rough terrain", "Dual feed wheel system"],
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/bandit_19xp_chipper.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/bandit_19xp_chipper.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/bandit_19xp_chipper.png-wvc-sizes",
    alt: "Bandit Intimidator 19XP Tracked Wood Chipper"
  }
}, {
  id: "eq-2",
  name: "Fecon FTX150",
  model: "FORESTRY MULCHER",
  specs: ["150 HP Cummins engine", "Bull Hog mulching head", "Low ground pressure (3.7 psi)", "Severe duty cooling system"],
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/fecon_ftx150_mulcher.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/fecon_ftx150_mulcher.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/fecon_ftx150_mulcher.png-wvc-sizes",
    alt: "Fecon FTX150 Forestry Mulcher"
  }
}, {
  id: "eq-3",
  name: "Rayco RG74T-R",
  model: "STUMP CUTTER",
  specs: ["74 HP Cummins diesel engine", "Expandable rubber tracks", "Radio remote control operation", "Massive 28-inch cutting wheel"],
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/rayco_rg74t_stump_cutter.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/rayco_rg74t_stump_cutter.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/rayco_rg74t_stump_cutter.png-wvc-sizes",
    alt: "Rayco RG74T-R Stump Cutter"
  }
}, {
  id: "eq-4",
  name: "CAT 299D3 XE",
  model: "COMPACT TRACK LOADER",
  specs: ["110 Gross HP", "High Flow XPS hydraulics", "Forestry guarding package", "Multi-tool attachment capable"],
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/cat_299d3_loader.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/cat_299d3_loader.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/cat_299d3_loader.png-wvc-sizes",
    alt: "CAT 299D3 XE Compact Track Loader"
  }
}];
export default function EquipmentCapabilities() {
  const [api, setApi] = React.useState<CarouselApi>();
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  React.useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      if (api.canScrollNext()) {
        api.scrollNext();
      } else {
        api.scrollTo(0);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [api]);
  return;
}